// @flow

// Vendors
import React, { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { submitPaymentFromForm } from '../../../../reducers/payment/paymentActions';
import { goBack } from 'connected-react-router';

// Helpers
import { selectRenewalFee } from '../../../../reducers/app/appSelectors';

// Components
import { InputCheckbox, Content, FormActions, FormActionsItem } from '../../..';
import { ButtonPrimary, Button } from 'texkit/dist/components/Buttons';
import FeeSummary from '../../PaymentFeeSummary/PaymentFeeSummary';

// Helpers
import { PaymentContext } from '../../Payment';
import { clearAlertInfo } from '../../../../reducers/alert/alertActions';

const ReviewAndPay = () => {
  const paymentContext = useContext(PaymentContext);
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState();
  const [savePaymentAccount, setSavePaymentAccount] = useState(false);
  const feeInfo = useSelector(selectRenewalFee);
  const { walletStatus } = useSelector(state => state.payment);
  const handleSubmit = () => {
    dispatch(clearAlertInfo());
    setSubmitting(true);
    dispatch(
      submitPaymentFromForm(paymentContext, { savePaymentAccount })
    ).finally(() => setSubmitting(false));
  };

  const onCancel = () => {
    dispatch(clearAlertInfo());
    dispatch(goBack());
  };

  return (
    <>
      <h3 className="payment-review-subtitle">
        <Content type="Payment" id="ReviewInfo" />
      </h3>
      {feeInfo && <FeeSummary feeInfo={feeInfo} />}
      {walletStatus === 'SUCCESS' && (
        <InputCheckbox
          name="savePaymentAccount"
          label={<Content type="Labels" id="SaveCard" />}
          checked={savePaymentAccount}
          onChange={event => setSavePaymentAccount(!!event.target.checked)}
        />
      )}
      <FormActions>
        <FormActionsItem>
          <ButtonPrimary
            onClick={handleSubmit}
            isLoading={submitting}
            loadingContent={<Content type="Payment" id="Paying" />}
          >
            <Content type="Payment" id="PayNow" />
          </ButtonPrimary>
        </FormActionsItem>
        <FormActionsItem>
          <Button onClick={onCancel} disabled={submitting}>
            <Content type="Labels" id="Back" />
          </Button>
        </FormActionsItem>
      </FormActions>
    </>
  );
};

export default ReviewAndPay;
